// tslint:disable:no-any

import { IMultiposting } from '../../../../repositories/billing-tariffs/entities/PublishTerms/Multiposting';

export interface IMultiPosting {
  isMultipostingAvailable: boolean;
  multipostingABGroup: string;
}

export const mapMultiposting = (multiposting: IMultiposting | null | undefined): IMultiPosting => {
  if (!multiposting) {
    return {
      isMultipostingAvailable: false,
      multipostingABGroup: 'A',
    };
  }

  const { enabled: isMultipostingEnabled, group: multipostingABGroup } = multiposting;

  return {
    isMultipostingAvailable: Boolean(isMultipostingEnabled && multipostingABGroup && multipostingABGroup !== 'A'),
    multipostingABGroup: multipostingABGroup || 'A',
  };
};
